import { wsService } from "./wsService";

const section = "incidencias";

const CODE_LPN_NOT_FOUND   = "LPN_NOT_FOUND";
const CODE_PRODUCT_DAMAGED = "PRODUCT_DAMAGED";
const CODE_PRODUCT_MISSING = "PRODUCT_MISSING";
const CODE_OTHER           = "OTHER";

const CODE_NAMES = {
  [CODE_LPN_NOT_FOUND]:   "LPN no encontrado",
  [CODE_PRODUCT_DAMAGED]: "Producto Dañado",
  [CODE_PRODUCT_MISSING]: "Producto Faltante",
  [CODE_OTHER]:           "Otro",
};

const STATE_RESOLVED     = 1;
const STATE_NOT_RESOLVED = 2;

const STATE_NAMES = {
  [STATE_RESOLVED]:     "Resuelta",
  [STATE_NOT_RESOLVED]: "No Resuelta",
};

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function list_codes() {
  return wsService.make_get_request(section + "/list_codes");
}

function list_states() {
  return wsService.make_get_request(section + "/list_states");
}

function resolve(ids) {
  // Asegurar que siempre sea un array
  const idsArray = Array.isArray(ids) ? ids : [ids];
  return wsService.make_post_request(section + "/resolve", { ids: idsArray });
}

function getCodeName(code) {
  return CODE_NAMES[code] || code;
}

function getStateName(state) {
  return STATE_NAMES[state] || state;
}

export const incidenciaService = {
  section,
  CODE_LPN_NOT_FOUND,
  CODE_PRODUCT_DAMAGED,
  CODE_PRODUCT_MISSING,
  CODE_OTHER,
  CODE_NAMES,
  STATE_RESOLVED,
  STATE_NOT_RESOLVED,
  STATE_NAMES,
  filter,
  get,
  list_codes,
  list_states,
  resolve,
  getCodeName,
  getStateName,
};
